import React from 'react';
import MuiPopover, { PopoverProps as MuiPopoverProps, PopoverOrigin as MuiPopoverOrigin } from '@mui/material/Popover';
import { BpDesignSystem } from '../../types';

export type PopoverOrigin = MuiPopoverOrigin;

export type PopoverProps = BpDesignSystem.PropsWithChildren<MuiPopoverProps>;

const DEFAULT_ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'center'
};

const DEFAULT_TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'center'
};

export const Popover: React.FC<React.PropsWithChildren<PopoverProps>> = ({
  open,
  anchorEl,
  onClose,
  children,
  slotProps = {},
  anchorOrigin = DEFAULT_ANCHOR_ORIGIN,
  transformOrigin = DEFAULT_TRANSFORM_ORIGIN,
  dataTest = 'popover',
  ...props
}) => (
  <MuiPopover
    transitionDuration={150}
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={anchorOrigin}
    transformOrigin={transformOrigin}
    data-test={dataTest}
    slotProps={{
      paper: {
        square: true,
        ...slotProps.paper
      }
    }}
    {...props}
  >
    {children}
  </MuiPopover>
);
